function getDefaultApiUrl() {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_API_URL || 'http://localhost:5000';
  }

  const { protocol, hostname, origin } = window.location;
  const isLocalHost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0';

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (isLocalHost) {
    return `${protocol}//${hostname}:5000`;
  }

  return origin;
}

export const API_URL = getDefaultApiUrl();

const STORAGE_KEY = 'travelerUser';
const AUTH_EVENT = 'traveler-auth-changed';

export function readStoredUser() {
  const storedUser = window.localStorage.getItem(STORAGE_KEY);
  return storedUser ? JSON.parse(storedUser) : null;
}

export function persistUser(nextUser) {
  if (nextUser) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextUser));
  } else {
    window.localStorage.removeItem(STORAGE_KEY);
  }

  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function clearStoredUser() {
  window.localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function getAuthEventName() {
  return AUTH_EVENT;
}

export async function fetchJson(path, options = {}) {
  const response = await fetch(`${API_URL}${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });

  let payload = {};

  try {
    payload = await response.json();
  } catch (_error) {
    payload = {};
  }

  return { response, payload };
}

export async function refreshStoredUser() {
  if (!readStoredUser()) {
    return null;
  }

  const { response, payload } = await fetchJson('/auth/session', {
    method: 'GET',
  });

  if (!response.ok || !payload.user) {
    if (response.status === 401 || response.status === 403) {
      clearStoredUser();
    }

    throw new Error(payload.message || 'Unable to refresh account.');
  }

  persistUser(payload.user);
  return payload.user;
}
